import { BaseProcessor, ColumnMetaData } from './BaseProcessor';

export class EventplotChart extends BaseProcessor {
  protected chartType = 'scatter';

  constructor(
    data: { [key: string]: any }[],
    xAxis: string[],
    yAxis: string[],
    columnsMetaData: { [key: string]: ColumnMetaData } = {},
    options: any = {}
  ) {
    super();
    this.data = data;
    this.xAxis = xAxis;
    this.yAxis = yAxis;
    this.columnsMetaData = columnsMetaData;
    this.options = options;
    this.addChartTypeToOptions();
  }

  addToolTip() {
    this.options.tooltip = {
      headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
      pointFormatter: function () {
        // Format point.y with commas as thousands separator
        const formattedY =
          typeof this.y === 'number'
            ? this.y.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : this.y;
        return `<span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${formattedY}</b><br/>`;
      },
    };
  }

  addXAxisData() {
    if (this.xAxis.length > 0) {
      if (this.isDateTime(this.columnsMetaData[this.xAxis[0]].type)) {
        // If x-axis values are datetime, set xAxis type to 'datetime'
        this.options.xAxis.type = 'datetime';
        // Set xAxis label format based on datatype
        const xAxisMeta = this.columnsMetaData[this.xAxis[0]];
        if (xAxisMeta?.type === 'datetime') {
          this.options.xAxis.labels = {
            format: '{value:%Y-%m-%d}',
          };
        } else if (xAxisMeta?.type === 'year') {
          this.options.xAxis.labels = {
            formatter: function () {
              // Show only the year part
              const date = new Date(this.value);
              return date.getFullYear();
            },
          };
        } else if (xAxisMeta?.type === 'month') {
          this.options.xAxis.labels = {
            formatter: function () {
              // Show as "Jan,2025"
              const date = new Date(this.value);
              const month = date.toLocaleString('default', { month: 'short' });
              const year = date.getFullYear();
              return `${month},${year}`;
            },
          };
        } else {
          this.options.xAxis.labels = {
            format: '{value}',
          };
        }
      }
    }
  }

  protected preprocessData() {
    delete this.options.series;
    delete this.options.data;
    let data = [[...this.xAxis, ...this.yAxis]];
    this.data.forEach((values: any) => {
      data.push(
        data[0].map((cols: any) => {
          return this.formateValueWithType(
            values[cols],
            this.columnsMetaData[cols]
          );
        })
      );
    });

    this.options.data = {
      rows: data,
    };
    this.addXAxisTitle();
    this.addYAxisTitle();
    this.addXAxisData();
    this.addToolTip();
  }
}
